<!-- ----------------------------------------------- -->
<template>
  <v-col class="obs-col pa-0">
    <div class="obs-card-list">
      <div class="obs-scroll pb-2">
        <tm-rain-frame v-if="reqParam.itmkndCd === 1">雨量観測所</tm-rain-frame>
        <tm-bsn-frame v-if="reqParam.itmkndCd === 2"
          >流域平均観測所情報</tm-bsn-frame
        >
        <tm-snow-frame v-if="reqParam.itmkndCd === 3">積雪観測所</tm-snow-frame>
        <tm-stage-frame v-if="reqParam.itmkndCd === 4"
          >水位観測所</tm-stage-frame
        >
        <tm-wtr-qual-frame v-if="reqParam.itmkndCd === 6"
          >水質観測所</tm-wtr-qual-frame
        >
        <tm-dam-frame v-if="reqParam.itmkndCd === 7">ダム観測所</tm-dam-frame>
        <tm-coast-frame v-if="reqParam.itmkndCd === 12"
          >海岸観測所</tm-coast-frame
        >
        <tm-rd-bsn-frame v-if="reqParam.itmkndCd === 20"
          >レーダ流域観測所</tm-rd-bsn-frame
        >
        <tm-cctv-frame v-if="reqParam.itmkndCd === 100"
          >河川カメラ</tm-cctv-frame
        >
        <tm-sw-stage-frame v-if="reqParam.itmkndCd === 300"
          >水位計</tm-sw-stage-frame
        >
        <tm-scam-frame v-if="reqParam.itmkndCd === 200"
          >簡易カメラ</tm-scam-frame
        >
      </div>
    </div>
  </v-col>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]個別観測所画面
 * TmObs.vue
 * @author ILUKE
 */

import mixin from "./../../../lib/mixin.js";
import Util from "./../../../lib/util";
import TmStageFrame from "../../../components/pc/TmStageFrame.vue";
import TmRainFrame from "../../../components/pc/TmRainFrame.vue";
import TmDamFrame from "../../../components/pc/TmDamFrame.vue";
import TmWtrQualFrame from "../../../components/pc/TmWtrQualFrame.vue";
import TmSnowFrame from "../../../components/pc/TmSnowFrame.vue";
import TmCoastFrame from "../../../components/pc/TmCoastFrame.vue";
import TmRdBsnFrame from "../../../components/pc/TmRdBsnFrame.vue";
import TmBsnFrame from "../../../components/pc/TmBsnFrame.vue";
import TmCctvFrame from "../../../components/pc/TmCctvFrame.vue";
import TmSwStageFrame from "../../../components/pc/TmSwStageFrame.vue";
import TmScamFrame from "../../../components/pc/TmScamFrame.vue";

export default {
  mixins: [mixin],
  data() {
    return {};
  },
  components: {
    TmStageFrame,
    TmRainFrame,
    TmDamFrame,
    TmWtrQualFrame,
    TmSnowFrame,
    TmCoastFrame,
    TmRdBsnFrame,
    TmBsnFrame,
    TmCctvFrame,
    TmSwStageFrame,
    TmScamFrame,
  },
  created() {
    const urlTime = this.$route.query["tmtime"];
    if (urlTime != undefined) {
      let setTime = new Date();
      if (Util.formatDate(urlTime) !== "Invalid Date") {
        setTime = Util.toDate(urlTime);
      }
      // 5分単位に丸める
      setTime.setMinutes(Math.floor(setTime.getMinutes() / 5) * 5);
      this.$store.commit("app/setTime", setTime);
    }
  },
  mounted: function() {
    this.$log.debug("[TmObs] mounted()");

    // ブラウザバック時にリロードイベントを登録
    window.addEventListener("popstate", this.reload, false);

    this.initObs();
    // 種別コードがない場合は概況画面へ遷移
    if (!this.reqParam.itmkndCd) {
      this.routerPcHome();
    }
  },
  /** 破棄部 */
  destroyed() {
    // リロードイベントを削除
    window.removeEventListener("popstate", this.reload, false);
  },
  computed: {
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        if (
          this.$store.state.Telemeter.selectedTmParam.itmkndCd &&
          Number(this.$route.query["itmkndCd"]) !== 300
        ) {
          // 危機管理水位が選択されていない場合
          return this.$store.state.Telemeter.selectedTmParam;
        } else {
          return this.$store.state.Swin.selectedSwParam;
        }
      },
    },
  },
  methods: {
    /** リロード */
    reload() {
      /** 選択中テレメータ情報パラメータセット */
      this.setUrlSelectedTmParam();

      /** 表示コンテンツのセット */
      this.$log.debug("[TmObs] setContent-TmObs");
      this.$store.commit("app/setContent", "TmObs");
    },
    /** 初期化処理 */
    initObs() {
      /** URLからの遷移はGETから選択中テレメータ情報パラメータセット */
      if (!this.selectedTmParamCheck()) {
        /** 選択中テレメータ情報パラメータセット */
        this.setUrlSelectedTmParam();
      }

      /** 表示コンテンツのセット */
      this.$log.debug("[TmObs] setContent-TmObs");
      this.$store.commit("app/setContent", "TmObs");
    },
    /** 選択中テレメータ情報パラメータチェック */
    selectedTmParamCheck() {
      if (
        this.$store.state.Telemeter.selectedTmParam.ofcCd &&
        this.$store.state.Telemeter.selectedTmParam.itmkndCd &&
        (this.$store.state.Telemeter.selectedTmParam.obsCd ||
          this.$store.state.Telemeter.selectedTmParam.cctvCd ||
          this.$store.state.Telemeter.selectedTmParam.scamId ||
          this.$store.state.Telemeter.selectedTmParam.ownCd ||
          this.$store.state.Telemeter.selectedTmParam.sysCamId ||
          this.$store.state.Telemeter.selectedTmParam.sysId)
      ) {
        return true;
      } else {
        return false;
      }
    },
    /** GETから選択中テレメータ情報パラメータセット */
    setUrlSelectedTmParam() {
      // url解析
      const ofcCd = isNaN(this.$route.query["ofcCd"])
        ? null
        : Number(this.$route.query["ofcCd"]);
      const itmkndCd = isNaN(this.$route.query["itmkndCd"])
        ? null
        : Number(this.$route.query["itmkndCd"]);
      const obsCd = isNaN(this.$route.query["obsCd"])
        ? null
        : Number(this.$route.query["obsCd"]);
      const cctvCd = isNaN(this.$route.query["cctvCd"])
        ? null
        : Number(this.$route.query["cctvCd"]);
      const scamId = isNaN(this.$route.query["scamId"])
        ? null
        : Number(this.$route.query["scamId"]);
      const ownCd = isNaN(this.$route.query["ownCd"])
        ? null
        : Number(this.$route.query["ownCd"]);
      const sysCamId = isNaN(this.$route.query["sysCamId"])
        ? null
        : Number(this.$route.query["sysCamId"]);
      const sysId = isNaN(this.$route.query["sysId"])
        ? null
        : Number(this.$route.query["sysId"]);

      if (itmkndCd == 300) {
        //危機管理型水位計情報を設定
        this.$store.commit("Swin/setSelectedSwParam", {
          swofcCd: ofcCd,
          itmkndCd: itmkndCd,
          swobsCd: obsCd,
          swcctvCd: cctvCd,
        });
      } else {
        // 選択中テレメータ情報を設定
        this.$store.commit("Telemeter/setSelectedTmParam", {
          ofcCd: ofcCd,
          itmkndCd: itmkndCd,
          obsCd: obsCd,
          cctvCd: cctvCd,
          scamId: scamId,
          ownCd: ownCd,
          sysCamId: sysCamId,
          sysId: sysId,
        });
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.obs-col {
  height: 100%;
  .obs-card-list {
    position: relative;
    height: 100%;
  }
  .obs-scroll {
    position: absolute;
    height: 100%;
    overflow: auto;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
  }
}
</style>
